import { SecondaryButton as V31SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { SecondaryButton as DeprecatedSecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { FilterOutlined as Filter24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/FilterOutlined";
import { StandardProps } from "@/types/types";
import styles from "./FilterDrawerButton.module.scss";
import { useState } from "react";
import classNames from "classnames/bind";
import { FilterDrawer } from "../__shared__/FilterDrawer/FilterDrawer";
import { extractAppliedFilters } from "../AppliedFilters/utils";
import { useFeatureFlags } from "@/flags/flags";

const cx = classNames.bind(styles);

type FilterDrawerButtonProps = Pick<
  StandardProps,
  "productListingData" | "configProps"
> & {
  name?: string;
  "data-testid"?: string;
  targetFacetName?: string;
};

export function FilterDrawerButton({
  productListingData,
  configProps,
  name,
  "data-testid": dataTestId,
  targetFacetName,
}: FilterDrawerButtonProps) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { facets } = productListingData;
  const { appliedFilters } = extractAppliedFilters(facets);
  const { isJldsV31Enabled } = useFeatureFlags();

  return (
    <>
      {isJldsV31Enabled?.value ? (
        <V31SecondaryButton
          data-testid={dataTestId || "filters-button"}
          data-component="FilterDrawerButton"
          className={cx("filterButton", {
            "filterButton--mobileOnly": !!configProps?.mobileOnly,
          })}
          onClick={() => {
            setDrawerOpen(true);
          }}
          icon={Filter24PxOutlinedIcon}
          labelText={`${name || "Filter"}${appliedFilters?.length > 0 ? ` (${appliedFilters.length})` : ""}`}
          width="full-width"
        />
      ) : (
        <DeprecatedSecondaryButton
          data-testid={dataTestId || "filters-button"}
          data-component="FilterDrawerButton"
          className={cx("filterButton", "filterButton--deprecated", {
            "filterButton--mobileOnly": !!configProps?.mobileOnly,
          })}
          onClick={() => {
            setDrawerOpen(true);
          }}
        >
          <span className={styles.filterIcon}>
            <Filter24PxOutlinedIcon size="medium" />
          </span>
          {`${name || "Filter"}${appliedFilters?.length > 0 ? ` (${appliedFilters.length})` : ""}`}
        </DeprecatedSecondaryButton>
      )}
      <FilterDrawer
        isOpen={drawerOpen}
        standardProps={{
          configProps,
          productListingData: productListingData,
        }}
        handleClose={() => {
          setDrawerOpen(false);
        }}
        targetFacetName={targetFacetName}
      />
    </>
  );
}
